import { getUserProfile } from '@cronos-app/api';
import { currentWallet } from '@cronos-app/wallet';
import { useSetUsernameModal } from '@ui/components/SetUsernameModal/useSetUsernameModal';

/** opens the set username modal if a connected user has no username yet */
export const ensureHasProfile = async (
  callbackOnComplete?: (username: string) => void,
): Promise<void> => {
  const walletAddress = currentWallet.getStore().getState().accounts?.[0];
  if (!walletAddress) return;

  try {
    const userProfile = await getUserProfile(walletAddress);
    if (!userProfile.name) {
      useSetUsernameModal.getState().openModal({ callbackOnComplete });
    } else {
      callbackOnComplete?.(userProfile.name);
    }
  } catch (error) {
    console.error('Error ensuring user has profile:', error);
  }
};
